import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByDateTime'
})
export class SortByDateTimePipe implements PipeTransform {

  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array)) {
      return array;
    }
    return array.sort((a: any, b: any) => {
      return new Date(a[field]).getTime() - new Date(b[field]).getTime();
    });
  }

}
